import { render, staticRenderFns } from "./accordion-checkout-payment.vue?vue&type=template&id=7c5513aa&"
import script from "./accordion-checkout-payment.vue?vue&type=script&lang=js&"
export * from "./accordion-checkout-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports